import { styled } from "@mui/material";

export const HederText = styled('h3')(({ theme }) => (props) => ({
    fontSize: '24px',
    fontWeight: 800,
    lineHeight: '29px',
    letterSpacing: '0em',
    margin: 0,
    color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary
}))
export const HederSection = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
}))